<script setup>
// Reklamlar bolumunun kabugu: kampanya > reklam seti > reklam hiyerarsisi
// ayni reklam hesabi uzerinde calisir. Hesap secimi bes sekmede ayri ayri
// sorulmasin diye kabukta bir kez yapilir, alt sayfalara prop olarak iner.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import MetaAdsKabuk from './MetaAdsKabuk.vue';

const { t } = useI18n();

// Sekme adlari dile bagli oldugu icin computed; dil degisince yeniden cevrilir.
const sekmeler = computed(() => [
  { ad: t('META_ADS.REKLAMLAR.KAMPANYALAR'), rota: 'meta_ads_kampanyalar' },
  { ad: t('META_ADS.REKLAMLAR.REKLAM_SETLERI'), rota: 'meta_ads_reklam_setleri' },
  { ad: t('META_ADS.REKLAMLAR.REKLAM_LISTESI'), rota: 'meta_ads_reklam_listesi' },
  { ad: t('META_ADS.REKLAMLAR.OTOMASYONLAR'), rota: 'meta_ads_otomasyonlar' },
  { ad: t('META_ADS.REKLAMLAR.AB_TESTLERI'), rota: 'meta_ads_ab_testleri' },
]);
</script>

<template>
  <MetaAdsKabuk
    :baslik="t('META_ADS.REKLAMLAR.BASLIK')"
    :sekmeler="sekmeler"
    :hesap-gerekli="true"
  />
</template>
